import { render, staticRenderFns } from "./teeth.vue?vue&type=template&id=0c095d4e&"
import script from "./teeth.vue?vue&type=script&lang=js&"
export * from "./teeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports